<template>
  <div :style="style">
    <swiper-container
      class="relative-postition"
      init="false"
      navigation="false"
      pagination="false"
      ref="swiper"
    >
      <swiper-slide
        v-for="slide in media"
        class="relative-position"
        :key="slide._key"
        :style="style"
      >
        <image-component v-if="slide.type === 'image'" crop :image="slide.image" :width="width" />
        <video-component v-else :src="slide.videoUrl" />
      </swiper-slide>
      <q-btn
        v-if="active"
        class="absolute-left z-top"
        color="primary"
        icon="chevron_left"
        flat
        :size="$q.screen.gt.sm ? 'lg' : 'xl'"
        @click="previousSlide"
      />
      <q-btn
        v-if="active"
        class="absolute-right z-top"
        color="primary"
        icon="chevron_right"
        flat
        :size="$q.screen.gt.sm ? 'lg' : 'xl'"
        @click="nextSlide"
      />
    </swiper-container>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue'
import { useQuasar } from 'quasar'
import { Autoplay, EffectFade } from 'src/boot/swiper'
import ImageComponent from 'src/components/image/ImageComponent.vue'
import VideoComponent from 'src/components/video/VideoComponent.vue'

defineOptions({ name: 'SectionRowSwiper' })

const props = defineProps({
  active: { type: Boolean, default: false },
  hover: { type: Boolean, default: false },
  media: { type: Array, default: () => [] },
  ratio: { type: Number, default: 16 / 9 },
  width: { type: Number, default: 480 },
})

const $q = useQuasar()
const swiper = ref(null)
const style = computed(() => {
  return {
    height: `calc(${props.width}px / ${props.ratio})`,
    width: `${props.width}px`,
  }
})

const params = {
  centeredSlides: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  grabCursor: false,
  injectStylesUrls: ['/css/fade-element.css'],
  loop: true,
  materialEffect: {
    slideSplitRatio: 0.65,
  },
  modules: [Autoplay, EffectFade],
  noSwiping: true,
  slidesPerView: 1,
  simulateTouch: false,
  spaceBetween: 0,
}

const previousSlide = () => {
  if (!swiper.value?.swiper) return

  swiper.value.swiper.slidePrev()
}

const nextSlide = () => {
  if (!swiper.value?.swiper) return

  swiper.value.swiper.slideNext()
}

onMounted(() => {
  Object.assign(swiper.value, params)
  nextTick(() => {
    if (swiper.value) {
      swiper.value.initialize()
    }
  })
})
</script>
